import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';
import { AppConfig } from 'src/app/app-config';
import { FeatureFlagsService } from './feature-flag.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Features } from './features';

export function featureFlagGuard(
  feature: Features,
  redirectToOldCMS: boolean,
  redirectRoute: string
): CanActivateFn {
  return (route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> => {
    const featureFlagsService: FeatureFlagsService =
      inject(FeatureFlagsService);
    const appConfig: AppConfig = inject(AppConfig);
    const router: Router = inject(Router);
    return featureFlagsService.isFeatureEnabledForUser$(feature).pipe(
      map((isFeatureEnabledForUser) => {
        if (!isFeatureEnabledForUser && redirectToOldCMS) {
          var redirectUrl = appConfig.cmsUrl + redirectRoute;

          Object.keys(route.params).forEach(function (e) {
            redirectUrl = redirectUrl.replace(`:${e}`, route.params[e]);
          });
          document.location.href = redirectUrl;
          return false;
        }

        return isFeatureEnabledForUser || router.createUrlTree([redirectRoute]);
      })
    );
  };
}
